export const EMPLOYEES_LIST_REQUEST = "EMPLOYEES_LIST_REQUEST";
export const EMPLOYEES_LIST_RESPONSE = "EMPLOYEES_LIST_RESPONSE";

export const ADD_EMPLOYEE_REQUEST = "ADD_EMPLOYEE_REQUEST";

export const GET_EMPLOYEE_DETAILS_REQUEST =
  "GET_EMPLOYEE_DETAILS_REQUEST";
export const GET_EMPLOYEE_DETAILS_RESPONSE =
  "GET_EMPLOYEE_DETAILS_RESPONSE";

export const EDIT_EMPLOYEE_REQUEST = "EDIT_EMPLOYEE_REQUEST";

export const ACTIVATE_EMPLOYEE_REQUEST = "ACTIVATE_EMPLOYEE_REQUEST";
export const DEACTIVATE_EMPLOYEE_REQUEST =
  "DEACTIVATE_EMPLOYEE_REQUEST";
